import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { Toaster } from './components/ui/sonner';
import Landing from './pages/Landing';
import Auth from './pages/Auth';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Onboarding from './pages/Onboarding';
import AppShell from './pages/AppShell';
import AskVet from './pages/app/AskVet';
import SymptomCheck from './pages/app/SymptomCheck';
import FindVets from './pages/app/FindVets';
import Profile from './pages/app/Profile';
import Reminders from './pages/app/Reminders';
import AddCat from './pages/app/AddCat';
import EditCat from './pages/app/EditCat';
import BreedId from './pages/app/BreedId';
import VetLanding from './pages/VetLanding';
import VetSignup from './pages/VetSignup';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import Legal from './pages/Legal';
import SmsOptIn from './pages/SmsOptIn';
import MarketingHome from './pages/MarketingHome';
import Beta from './pages/Beta';
import VetJoin from './pages/VetJoin';
import Admin from './pages/Admin';
import InstallPrompt from './components/InstallPrompt';

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/app" element={<AppShell />}>
              <Route index element={<AskVet />} />
              <Route path="ask" element={<AskVet />} />
              <Route path="symptoms" element={<SymptomCheck />} />
              <Route path="vets" element={<FindVets />} />
              <Route path="profile" element={<Profile />} />
              <Route path="reminders" element={<Reminders />} />
              <Route path="add-cat" element={<AddCat />} />
              <Route path="edit-cat/:id" element={<EditCat />} />
              <Route path="breed-id" element={<BreedId />} />
            </Route>
            <Route path="/vets" element={<VetLanding />} />
            <Route path="/vets/signup" element={<VetSignup />} />
            <Route path="/vets/join" element={<VetJoin />} />
            <Route path="/beta" element={<Beta />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/terms" element={<Legal doc="terms" />} />
            <Route path="/privacy" element={<Legal doc="privacy" />} />
            <Route path="/disclaimer" element={<Legal doc="disclaimer" />} />
            <Route path="/sms-optin" element={<SmsOptIn />} />
            <Route path="/purrflect" element={<MarketingHome />} />
            <Route path="/marketing" element={<MarketingHome />} />
          </Routes>
          <Toaster position="top-center" richColors />
          <InstallPrompt />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
